// extracted by mini-css-extract-plugin
export var content = "SimpleProLandingPage-module__content___pIzpG";
export var feature = "SimpleProLandingPage-module__feature___Hlev3";
export var features = "SimpleProLandingPage-module__features___YEqxz";
export var lottie = "SimpleProLandingPage-module__lottie___xiGS1";
export var link = "SimpleProLandingPage-module__link___mHD1E";
export var video = "SimpleProLandingPage-module__video___jKnV1";
export var hero = "SimpleProLandingPage-module__hero___ZIUEK";
export var picture = "SimpleProLandingPage-module__picture___n9t_U";
export var copy = "SimpleProLandingPage-module__copy___XXfu6";
export var headline = "SimpleProLandingPage-module__headline___rEt3o";
export var title = "SimpleProLandingPage-module__title___MJlVZ";
export var subhead = "SimpleProLandingPage-module__subhead___gUPSU";
export var head = "SimpleProLandingPage-module__head___AvFbL";
export var button = "SimpleProLandingPage-module__button___ILWqo";
export var cancel = "SimpleProLandingPage-module__cancel___JU8wZ";
export var wrapper = "SimpleProLandingPage-module__wrapper___DyTzc";
export var s = "SimpleProLandingPage-module__s___T6uSL";
export var chevron = "SimpleProLandingPage-module__chevron___mbxdv";
export var newBadge = "SimpleProLandingPage-module__newBadge___SgqY_";